<template>
  <NuxtI18nLink
    :to="isCyberSport ? '/cybersport/live' : '/sport/live'"
    class="live-now-link"
  >
    <div
      class="live-now"
      :class="{ ghost: isCyberSport }"
      data-t="live-now-4llt"
    >
      <StIcon name="play-solid" :size="16" />
      <p class="text">{{ t('sportHomePage.liveNow') }}</p>
      <StCounter
        :label="counter"
        bg-color="ghost"
        size="xs"
        color="white"
        live
      />
      <StIcon name="chevron-right" :size="16" />
    </div>
  </NuxtI18nLink>
</template>

<script setup lang="ts">
defineProps<{
  counter: number
  isCyberSport?: boolean
}>()

const { t } = useI18n()
</script>

<style scoped>
.live-now-link {
  text-decoration: none;
}

.live-now {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;

  padding: var(--spacing-150);

  color: var(--text-primary);

  background: var(--button-gray-default);
  border-radius: var(--border-radius-150);

  &.ghost {
    background: var(--button-ghost-default);
    backdrop-filter: blur(4px);
  }
}

.text {
  flex-grow: 1;
  margin: 0;
  font: var(--mobile-text-semibold);
}
</style>
